__turbopack_context__.v({
  "clickZone": "Sidebar-module-scss-module__-hPgtq__clickZone",
  "fullScreen": "Sidebar-module-scss-module__-hPgtq__fullScreen",
  "item": "Sidebar-module-scss-module__-hPgtq__item",
  "itemLink": "Sidebar-module-scss-module__-hPgtq__itemLink",
  "items": "Sidebar-module-scss-module__-hPgtq__items",
  "line-break": "Sidebar-module-scss-module__-hPgtq__line-break",
  "logo": "Sidebar-module-scss-module__-hPgtq__logo",
  "sidebar": "Sidebar-module-scss-module__-hPgtq__sidebar",
  "sidebarClose": "Sidebar-module-scss-module__-hPgtq__sidebarClose",
  "text-align_center": "Sidebar-module-scss-module__-hPgtq__text-align_center",
});
